import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.barChart`;

export const INIT = `${SCOPE}/INIT`;
